module.exports = __webpack_public_path__ + "img/health_help.59415ba0.svg";